import React from 'react';
import * as styles from './styles.css';
import { Button, UIHeading3, UIText2 } from '@cian/ui-kit';
import { NBSP, PERCENT, RUB } from '../../../common/constants';
import { formatNumberWithSpaces, transformNumToString } from '../../../common/utils';
import { BanksLogoList } from '../BanksLogoList';
import { getDeclension } from './utils/getDeclension';
import { ETestIds } from '../../constants';

export interface IOffersSummaryProps {
  minRate: number;
  minMonthlyPayment: number;
  totalOffersCount: number;
  bankLogosPaths: string[];
  onCtaClick: () => void;
  isLoading: boolean;
}

export const OffersSummary: React.FC<IOffersSummaryProps> = ({
  minMonthlyPayment,
  minRate,
  bankLogosPaths,
  totalOffersCount,
  onCtaClick,
  isLoading,
}) => {
  const declensionPart = getDeclension(totalOffersCount);

  return (
    <div className={styles['container']} data-testid={ETestIds.MobileSummaryContainer}>
      <div className={styles['numbers']}>
        <div className={styles['numbers-block']}>
          <UIText2>Платёж в месяц</UIText2>
          <UIHeading3>{'от' + NBSP + formatNumberWithSpaces(minMonthlyPayment) + NBSP + RUB}</UIHeading3>
        </div>
        <div className={styles['numbers-block']}>
          <UIText2>Ставка</UIText2>
          <UIHeading3>{'от' + NBSP + transformNumToString(minRate) + PERCENT}</UIHeading3>
        </div>
      </div>
      <div>
        <BanksLogoList banks={bankLogosPaths} />
      </div>
      <div className={styles['button']}>
        <Button size={'M'} fullWidth onClick={onCtaClick} loading={isLoading} data-testid={ETestIds.ShowOffersButton}>
          Смотреть {declensionPart}
        </Button>
      </div>
    </div>
  );
};
